import * as React from "react";

function SvgSerenytics(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".Serenytics_svg__st1,.Serenytics_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#2a4c7c}.Serenytics_svg__st2{fill:#e73a47}"
        }
      </style>
      <path
        fill="none"
        id="Serenytics_svg__canvas_background"
        d="M-1-1h442v112H-1z"
      />
      <g>
        <g id="Serenytics_svg__Layer_3">
          <path
            id="Serenytics_svg__svg_2"
            d="M25 22.3C38.1 9.2 57 5.6 73.3 11.5 58.7 7 42.2 10.5 30.7 22c-16.5 16.5-16.5 43.4 0 59.9s43.4 16.5 59.9 0c11.5-11.5 15-28 10.5-42.6 5.9 16.3 2.3 35.2-10.8 48.3-18 18-47.3 18-65.3 0S7 40.4 25 22.3z"
            className="Serenytics_svg__st1"
          />
        </g>
        <g id="Serenytics_svg__Layer_4">
          <path
            id="Serenytics_svg__svg_3"
            d="M32.8 23.7c-11.2 11.2-14.3 27.5-9.3 41.5-3.9-12.5-.9-26.7 9-36.6 14.2-14.2 37.3-14.2 51.5 0 14.2 14.2 14.2 37.3 0 51.5-9.9 9.9-24.1 12.9-36.6 9 14 5 30.3 1.9 41.5-9.3 15.5-15.5 15.5-40.6 0-56.1s-40.6-15.5-56.1 0z"
            className="Serenytics_svg__st2"
          />
        </g>
        <g id="Serenytics_svg__Layer_5">
          <path
            id="Serenytics_svg__svg_4"
            d="M82.7 55.2V77c-3.6 4.1-8.3 7.3-13.6 9.1V45.3c0-1.1.9-1.9 1.9-1.9h9.7c1.1 0 1.9.9 1.9 1.9l.1 9.9z"
            className="Serenytics_svg__st1"
          />
        </g>
        <g id="Serenytics_svg__Layer_6">
          <path
            id="Serenytics_svg__svg_5"
            d="M65.4 56.4V87.1c-2.1.5-4.4.7-6.7.7-2.4 0-4.7-.3-7-.8V54.1c0-1.1.9-1.9 1.9-1.9h9.7c1.1 0 1.9.9 1.9 1.9v2.3h.2z"
            className="Serenytics_svg__st2"
          />
        </g>
        <g id="Serenytics_svg__Layer_7">
          <path
            id="Serenytics_svg__svg_6"
            d="M47.7 66.2v19.7c-5.4-2-10.1-5.4-13.6-9.7V61c0-1.1.9-1.9 1.9-1.9h9.7c1.1 0 1.9.9 1.9 1.9v5.2h.1z"
            className="Serenytics_svg__st1"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSerenytics);
